
import { Injectable } from '@angular/core';
import * as CustomerActions from './customer.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, tap, catchError, of } from 'rxjs';
import CustomerService from '../../services/CustomerService';
import UserService from '../../services/UserService';
import EmployeeService from '../../services/EmployeeService';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable()
export class CustomerEffects {
  getAllCustomers$;
  getRegisteredCustomers$;
  getCustomerById$;
  getCustomerByUserName$;
  updateCoins$;
  getGatewayCustomerByReflexId$;
  getCustomerByReflexId$;
  getCurrentCustomer$;
  getContactDataByNameShorthand$;
  setEntraUserEnabledState$;
  getCustomerEmployees$;

  constructor(
    private actions$: Actions, 
    private service: CustomerService, 
    private userService: UserService,
    private employeeService: EmployeeService,
    private snackBar: MatSnackBar
  ) {
    this.getAllCustomers$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.getAllCustomers),
        mergeMap(() =>
          this.service.getAllCustomers().pipe(
            map((customers) => CustomerActions.getAllCustomersSuccess({ customers }))
          )
        )
      )
    );
    this.getRegisteredCustomers$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.getRegisteredCustomers),
        mergeMap(() =>
          this.service.getRegisteredCustomers().pipe(
            map((customers) => CustomerActions.getRegisteredCustomersSuccess({ customers }))
          )
        )
      )
    );
    this.getCustomerById$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.getCustomerById),
        mergeMap(({ id }) =>
          this.service.getCustomerById(id).pipe(
            map((customer) => CustomerActions.getCustomerByIdSuccess({ customer }))
          )
        )
      )
    );
    this.getCustomerByReflexId$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.getCustomerByReflexId),
        mergeMap(({ id }) =>
          this.service
            .getCustomerByReflexCustomerNo(id)
            .pipe(
              map((customer) =>
                CustomerActions.getCustomerByReflexIdSuccess({ customer })
              )
            )
        )
      )
    );
    this.getGatewayCustomerByReflexId$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.getGatewayCustomerByReflexId),
        mergeMap(({ id }) =>
          this.service
            .getGatewayCustomerByReflexCustomerNo(id)
            .pipe(
              map((customer) =>
                CustomerActions.getGatewayCustomerByReflexIdSuccess({
                  customer,
                })
              )
            )
        )
      )
    );
    this.getCustomerByUserName$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.getCustomerByUserName),
        mergeMap(({ userName }) =>
          this.service
            .getCustomerByUserName(userName)
            .pipe(
              map((customer) =>
                CustomerActions.getCustomerByUserNameSuccess({ customer })
              )
            )
        )
      )
    );
    this.getCurrentCustomer$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.getCurrentCustomer),
        mergeMap(() =>
          this.userService
            .getMe()
            .pipe(
              map((response) => {
                // Extract customer from the new unified response
                if (response.userType === 'customer' && response.customer) {
                  return CustomerActions.getCurrentCustomerSuccess({ customer: response.customer });
                }
                // If not a customer, return empty state or error
                throw new Error('User is not a customer');
              }),
              catchError((error) => {
                console.error('Error fetching current customer:', error);
                return of(CustomerActions.getCurrentCustomerFailure({ error: error.message }));
              })
            )
        )
    ));
    this.updateCoins$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.updateCoins),
        mergeMap(({ request }) =>
          this.service
            .updateCoins(request)
            .pipe(
              map((customer) =>
                CustomerActions.updateCoinsSuccess({ customer })
              )
            )
        )
      )
    );
    this.getContactDataByNameShorthand$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.getContactDataByNameShorthand),
        mergeMap(({ shorthand }) =>
          this.service.getContactDataByNameShorthand(shorthand).pipe(
            map((contact) =>
              CustomerActions.getContactDataByNameShorthandSuccess({ contact })
            )
          )
        )
      )
    );
    this.setEntraUserEnabledState$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.setEntraUserEnabledState),
        mergeMap(({ customerId, action }) =>
          this.employeeService.setCustomerEntraUserEnabledState(customerId, action).pipe(
            map((customers) => CustomerActions.setEntraUserEnabledStateSuccess({ customers }))
          )
        )
      )
    );
    this.getCustomerEmployees$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CustomerActions.getCustomerEmployees),
        mergeMap(() =>
          this.service.getCustomerEmployees().pipe(
            map((employees) => CustomerActions.getCustomerEmployeesSuccess({ employees }))
          )
        )
      )
    );
  }
}
